import { Popup } from "react-map-gl";
import { HazardIdEnum } from "../riskAssessment/hazardIdEnum";
import { LngLat } from "mapbox-gl";

export const detectNeedForExplosionPopup = (
  features: any[],
  coordinates: LngLat,
  setExplosionInfo: Function,
) => {
  let properties;
  let layer;

  if (features && features.length > 0) {
    properties = features[0].properties;
    layer = features[0].layer?.id;
  }

  if (properties && layer === "hazard-layer-secondary-" + HazardIdEnum.ExplosionIta) {
    setExplosionInfo({
      properties: {
        description: properties["Attivita"],
        organization: properties["Ragione Sociale"],
        ...properties,
      },
      lngLat: coordinates,
    });
  } else {
    setExplosionInfo(null);
  }
};

export const renderExplosionPopup = (explosionInfo: any) => {
  if (explosionInfo) {
    return (
      <Popup longitude={explosionInfo.lngLat.lng} latitude={explosionInfo.lngLat.lat} closeButton={false}>
        <strong>Explosion Hazard</strong>
        <hr />
        <div>
          <b>Organization</b>: {explosionInfo.properties.organization}
        </div>
        <div>
          <b>Description</b>: {explosionInfo.properties.description}
        </div>
      </Popup>
    );
  }
  return null;
};
